import type { HeatNoString, IndividualResult } from '@/components/results/store-comp-results'
import { cleanUpScoreValueForDisplay } from '@/components/results/results-service'
import type {
  SocketsResultsPfPayload,
  SocketsResultsPfPayloadFieldResult
} from '@/components/results/socket/socket-results-pf/sockets-results-pf-models'

export function mapSocketTrackResultToIndividualResult(
  socketsResultsPfPayloadFieldResult: SocketsResultsPfPayloadFieldResult
): IndividualResult {
  return {
    laneNo: socketsResultsPfPayloadFieldResult.options.lane,
    position: socketsResultsPfPayloadFieldResult.options.place,
    wind: socketsResultsPfPayloadFieldResult.options.ws.toString(),
    athlete: socketsResultsPfPayloadFieldResult.options.athlete,
    athleteId: socketsResultsPfPayloadFieldResult.athleteid,
    affilation: socketsResultsPfPayloadFieldResult.options.club,
    bibNo: socketsResultsPfPayloadFieldResult.options.bibNo.toString(),
    score: cleanUpScoreValueForDisplay(socketsResultsPfPayloadFieldResult.resultvalue),
    qualify: '',
    ageGroup: socketsResultsPfPayloadFieldResult.options.ageGroup
  }
}

export function mapSocketTrackResultsToIndividualResults(
  socketsResultsPfPayload: SocketsResultsPfPayload
): Record<HeatNoString, IndividualResult[]> {
  const result: Record<HeatNoString, IndividualResult[]> = {}
  result[socketsResultsPfPayload.heatNo.toString()] = socketsResultsPfPayload.results.map(
    mapSocketTrackResultToIndividualResult
  )
  return result
}
